/**
 * Created by kaijian.lei on 2017/11/7.
 * @providesModule StorageUtilsX
 */
import AsyncStorage from '@react-native-community/async-storage';
const EXPIRES = 31 * 24 * 60 * 60 * 1000;
const PREFIX = 'Q_';
let storage = null;
//调用RN的AsyncStorage
//根据key获取value
export const getItem = (key) => {
    return new Promise((resolve, reject) => {
        AsyncStorage.getItem('Q_'+key, (err, res)=>{
            if(err) {
            	resolve(null)
            } else {
                if(res) {
                    let value = JSON.parse(res).value;
                    resolve(value);
                } else {
                    resolve(null)
                }

            }
        });
    });
}

//存入数据
export const setItem = (key, value) => {
    try {
        AsyncStorage.setItem('Q_'+key, JSON.stringify({
            expires: new Date().getTime() + EXPIRES,
            value: value
        }));
    }
    catch (e) {
        console.error(e)
    }
}

const hasLocalStorage = (function () {
    try {
        storage = window.localStorage;
        storage.setItem('isOk', 'ok');
        storage.getItem('isOk');
        storage.removeItem('isOk');
        return true;
    } catch (e) {
        return false;
    }
})();


export const setItemSync = (key, value = '', expires = EXPIRES) => {
    if (hasLocalStorage) {
        value = {
            expires: Date.now() + expires,
            value: value
        };
        value = JSON.stringify(value);
        storage.setItem(PREFIX + key, value);
        return true;
    }

    return false;
};


export const getItemSync = (key) => {
    if (hasLocalStorage) {
        let value = storage.getItem(PREFIX + key);
        if (value === null) {
            return false;
        }
        value = JSON.parse(value);

        if (value.expires > Date.now()) {
            return value.value;
        }
        return false;
    }
    return true;
};

const StorageUtils = {
    getItem,
    setItem,
    getItemSync,
    setItemSync
}
export default StorageUtils
